import axios from 'axios';
import Vue from 'vue';
import router from './router';
import VueAxios from 'vue-axios';
import VueCookies from 'vue-cookies'
import VueAuth from '@websanova/vue-auth'
import vuetify from './plugins/vuetify';
import vueHeadful from 'vue-headful';

Vue.use(VueCookies);
Vue.use(VueAxios, axios);

Vue.axios.defaults.baseURL = 'https://landing-page.alidropship.com/rest/v1';

Vue.router = router;

Vue.use(VueAuth, {
    auth        : require('./auth.js'),
    http        : require('@websanova/vue-auth/drivers/http/axios.1.x.js'),
    router      : require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),
    rolesVar    : 'role',
    refreshData : { url: 'auth/refresh', method: 'POST', enabled: true, interval: 10 },
    fetchData   : { url: 'auth/user', method: 'POST', enabled: true }
});

Vue.component('vue-headful', vueHeadful);
Vue.component( 'Navigation', require('./components/Navigation.vue').default );
Vue.component( 'AppBar', require('./components/AppBar.vue').default );

const app = new Vue({
    router : Vue.router,
    vuetify
}).$mount('#wrap');